var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learned-button"},[_c('b-button',{ref:"button",attrs:{"type":"is-primary","icon-left":"check"},on:{"click":_vm.onClick}},[_vm._v("Gelernt")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }